var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { SvgIcon as Svg } from 'ha/ui/SvgIcon';

const SvgNoImage = props => /*#__PURE__*/React.createElement(Svg, _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 75.886,
  height: 75.032,
  viewBox: "0 0 75.886 75.032"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 391"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 390"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 457",
  d: "M70.641 75.032H5.235a5.236 5.236 0 010-10.472h60.169V35.112L37.652 12.073l-27.18 23.011v12.55a5.236 5.236 0 01-10.472 0V32.655a5.227 5.227 0 011.856-4L34.244 1.239a5.237 5.237 0 016.731-.029l33.016 27.419a5.23 5.23 0 011.9 4.027v37.139a5.248 5.248 0 01-5.25 5.237z",
  fill: "#e5e8e9"
})))));

export default SvgNoImage;